import styled from '@emotion/styled';
import { Magnetic } from '@mitchell/react.component.ux';
export const CarrierSectionContainer = styled('div') `
	margin-bottom: ${Magnetic.spacer48};
`;
export const RememberToText = styled('div', {
    shouldForwardProp: prop => prop !== 'fontWeight'
}) `
	color: ${Magnetic.colorBlack};
	text-align: center;
	font-size: ${Magnetic.fontSize12};
	max-width: 100%;
	width: 220px;
	margin: ${Magnetic.spacer08} auto;
	font-weight: ${props => props.fontWeight};
`;
//# sourceMappingURL=IntelligentRetakePageView.style.js.map